/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Message Button Container
 */

import { hocCompose, withErrorBoundary } from '@zcode/react-utils'
import { connect } from 'react-redux'
import { mapDispatchToProps, mapStateToProps } from './MessageButtonContainer'
import { MessageButtonListCard } from './MessageButtonListCard'

export const MessageButtonListCardContainer = hocCompose(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true }),
  withErrorBoundary({ displayName: 'MessageButton' }),
  MessageButtonListCard
)
